const investorsMainWrap = () => import("@/views/main_wrap.vue");

const createInvestorsViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: investorsMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const investorsRoutes = [
    createInvestorsViewRoute({
        path: "/investors/message-from-chairman",
        name: "Gsrin0100",
        aliases: ["/gsrin0100", "/investors/gsrin0100"],
        component: () => import("@/views/investors/01/gsrin0100.vue")
    }),
    createInvestorsViewRoute({
        path: "/investors/corporate-governance",
        name: "Gsrin0101",
        aliases: [
            "/gsrin0101",
            "/gsrin0102",
            "/gsrin0103",
            "/gsrin0104",
            "/investors/gsrin0101",
            "/investors/gsrin0102",
            "/investors/gsrin0103",
            "/investors/gsrin0104"
        ],
        component: () => import("@/views/investors/01/gsrin0101.vue")
    }),
    createInvestorsViewRoute({
        path: "/investors/financial-performance",
        name: "Gsrin0201",
        aliases: [
            "/gsrin0201",
            "/gsrin0202",
            "/gsrin0203",
            "/investors/gsrin0201",
            "/investors/gsrin0202",
            "/investors/gsrin0203"
        ],
        component: () => import("@/views/investors/02/gsrin0201.vue")
    }),
    createInvestorsViewRoute({
        path: "/investors/disclosures",
        name: "Gsrin0301",
        aliases: [
            "/gsrin0301",
            "/gsrin030201",
            "/gsrin030202",
            "/gsrin030203",
            "/gsrin0303",
            "/gsrin030301",
            "/investors/gsrin0301",
            "/investors/gsrin030201",
            "/investors/gsrin030202",
            "/investors/gsrin030203",
            "/investors/gsrin0303",
            "/investors/gsrin030301"
        ],
        component: () => import("@/views/investors/03/gsrin0301.vue")
    }),
    createInvestorsViewRoute({
        path: "/investors/stock-information",
        name: "Gsrin04",
        aliases: ["/gsrin04", "/investors/gsrin04"],
        component: () => import("@/views/investors/04/gsrin04.vue")
    })
];
